import { Component, OnInit, ChangeDetectionStrategy, inject, input } from '@angular/core';
import { stagger40ms } from '../../../@vex/animations/stagger.animation';
import { KeyValue } from '@angular/common';
import { LayoutService } from '../../../@vex/services/layout.service';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { Icons } from '../../util/Icons';
import { SessionService } from '../../services/session.service';
import { SnackbarService } from '../../services/snackbar.service';
import { Router } from '@angular/router';
import { BreadCrumbService } from '../../../@vex/components/breadcrumbs/BreadCrumbService';
import { ConfigService } from '../../services/config/config.service';
import { PageLayoutComponent } from '../../../@vex/components/page-layout/page-layout.component';
import { PageLayoutHeaderDirective } from '../../../@vex/components/page-layout/page-layout-header.directive';
import { BreadcrumbsComponent } from '../../../@vex/components/breadcrumbs/breadcrumbs.component';
import { PageLayoutContentDirective } from '../../../@vex/components/page-layout/page-layout-content.directive';
import { ContainerDirective } from '../../../@vex/directives/container/container.directive';

@Component({
	selector: 'development',
	templateUrl: './development.component.html',
	styleUrls: ['./development.component.scss'],
	animations: [stagger40ms],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [PageLayoutComponent, TranslocoDirective, PageLayoutHeaderDirective, BreadcrumbsComponent, PageLayoutContentDirective, ContainerDirective],
})
export class DevelopmentComponent implements OnInit {
	layoutService = inject(LayoutService);
	private readonly translocoService = inject(TranslocoService);
	sessionService = inject(SessionService);
	private readonly snackBar = inject(SnackbarService);
	private readonly router = inject(Router);
	private readonly configService = inject(ConfigService);
	icons = inject(Icons);
	breadCrumbService = inject(BreadCrumbService);

	readonly breadCrumbs = input<KeyValue<string, any>[]>(undefined);

	public argeExchangeUrl: string;
	public apiSections: string[] = [];

	ngOnInit(): void {
		if (
			!this.sessionService.isDevRole() &&
			!this.sessionService.isSupportRole() &&
			!this.sessionService.isPropertyManagement() &&
			!this.sessionService.isServiceProvider()
		) {
			this.snackBar.error(this.translocoService.translate('common.insufficientRights'));
			this.router.navigateByUrl('/dashboard');
		}

		this.translocoService.selectTranslate('development.apiDocu').subscribe(() => {
			this.breadCrumbService.reset();
			this.breadCrumbService.addBreadCrumb({
				translationKey: 'development.apiDocu',
				icon: this.icons.get('development'),
			});
		});
		this.argeExchangeUrl = this.configService.getArgeExchangeUrl();
		this.apiSections = ['development.argeConsumptionData', 'development.argeOnSite'];
	}
}
